// Mount the Fastchannel module: build its host from what only this app can supply and hand it to
// `createFastchannelModule`. `service-modules.ts` and `service-scopes.ts` take the routes and the
// catalog scopes from HERE, so the module cannot be mounted unregistered. The HTTP clients are not
// members: the module reads them from the shared registry (`@vnetwork/margarita-core/http`).
import { lazy, Suspense } from 'react';
import { brand } from '@/config/brand';
import { env } from '@/config/env';
import { createFastchannelModule, type FastchannelHost } from '@vnetwork/margarita-fastchannel';
import { withHostBase } from './host-base';

// Lazy: the player (and its CSS) renders only inside a channel's Preview tab. Imported eagerly here
// it would join the entry chunk; before the move it loaded with the module's own chunk.
const LazyHlsPreviewPlayer = lazy(() =>
  import('@vnetwork/margarita-shell/HlsPreviewPlayer').then((m) => ({ default: m.HlsPreviewPlayer })),
);
const HlsPreviewPlayer: FastchannelHost['HlsPreviewPlayer'] = (props) => (
  <Suspense fallback={null}>
    <LazyHlsPreviewPlayer {...props} />
  </Suspense>
);

export const fastchannel = createFastchannelModule(
  withHostBase(['trackFeatureAction'], {
    fastChannelUrl: env.fastChannelUrl,
    brandShortName: brand.shortName,
    HlsPreviewPlayer,
  }),
);
